import { IntlFormatters } from 'react-intl';

const getModalHeading = (formatMessage: IntlFormatters['formatMessage']) =>
  formatMessage({ id: 'receipt' });

export default getModalHeading;
